import React from 'react';
import { Link } from 'react-router-dom';
import './Gallery.css';
import Navbar from '../../Common/Navbar/Navbar';
import Footer from '../../Common/Footer/Footer';
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

const BASE_URL =
  "https://pm-website-assets.s3.ap-south-1.amazonaws.com/Assets/manifests";

const fetchImages = async (url) => {
  const res = await fetch(url);
  const images = await res.json();
  return images.map((src) => ({
    src,
    name: src.split("/").pop()
  }));
};

export default function Gallery() {
  const isDark = useSelector(state => state.functionslice.value.isDark);
  const [activeTab, setActiveTab] = useState("all");
  const [partnerimages, setPartnerImages] = useState([]);
  const [installations, setInstallations] = useState([]);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    fetchImages(`${BASE_URL}/partners.json`).then(setPartnerImages);
    fetchImages(`${BASE_URL}/installations.json`).then(setInstallations);
    fetchImages(`${BASE_URL}/events.json`).then(setEvents);
  }, []);

  const allProjects = [...installations, ...events];

  const getImages = () => {
    switch (activeTab) {
      case "installations":
        return installations;
      case "events":
        return events;
      default:
        return allProjects;
    }
  };

  return (
        <>
            <Navbar />
            <div className={`gallery-page ${isDark ? 'dark-theme' : ''}`}>
                <section className="gallery-hero">
                    <div className="gallery-hero-content">
                        <h1>Gallery & Collaborations</h1>
                        <p>Showcasing our partnerships, installations, and real-world impact in smart mobility solutions across cities worldwide.</p>
                    </div>
                </section>

                <section className="gallery-partners-section">
                    <h2>Trusted Partners</h2>

                    <div className="gallery-partners-row">
                        {partnerimages.map((img, index) => (
                            <img
                            key={index}
                            src={img.src}
                            alt={img.name}
                            className="gallery-partner-logo"
                            loading="lazy"
                            />
                        ))}
                        </div>
                </section>


                <section className={`gallery-projects-section ${isDark ? "dark" : ""}`}>
                    <div className="gallery-projects-tabs">
                        <span
                        className={activeTab === "all" ? "active-tab" : ""}
                        onClick={() => setActiveTab("all")}
                        >
                        All
                        </span>

                        <span
                        className={activeTab === "installations" ? "active-tab" : ""}
                        onClick={() => setActiveTab("installations")}
                        >
                        Installations
                        </span>

                        <span
                        className={activeTab === "events" ? "active-tab" : ""}
                        onClick={() => setActiveTab("events")}
                        >
                        Events
                        </span>
                    </div>

                    <div className="gallery-projects-grid">
                        {getImages().map((img, index) => (
                        <div key={index} className="gallery-project-card">
                            <img
                            src={img.src}
                            alt={img.name}
                            loading="lazy"
                            />
                        </div>
                        ))}
                    </div>
                    </section>


                <section className="gallery-cta-section">
                    <div className="gallery-cta-content">
                        <h2>Ready to Transform Your City?</h2>
                        <p>Join the growing network of cities leveraging Parimitra's AI-powered mobility solutions for smarter, safer transportation.</p>
                        <Link to="/contact">
                            <button className="gallery-btn-cta">Start Your Journey</button>
                        </Link>
                    </div>
                </section>
            </div>
            <Footer />
        </>
    );
}

// export default Gallery;
